module.exports = __webpack_public_path__ + "static/media/profile-frame-left.6b77f5ac.svg";